export default "__VITE_ASSET__CzCd035q__"